export default {
   methods: {
      td_alternate_class: function(index) {
         let classes = ['row'];
         if(index % 2 == 0) {
            classes.push('odd');
         } else {
            classes.push('even');
         }
         return classes;
      }
   }
}